export * from './components/Image/index';
//# sourceMappingURL=Image.js.map